import { motion } from 'framer-motion';
import styled from 'styled-components';

export const Container = styled(motion.div)`
  width: ${props => props.theme.width.container};
  max-width: ${props => props.theme.width.max};
  margin-inline: auto;
`;
